module.exports = __webpack_public_path__ + "img/Marca6.b955de8f.jpg";